module.exports = __webpack_public_path__ + "static/media/ODS15.1b671c1d.jpg";